// extracted by mini-css-extract-plugin
var _1 = "card--mOuic";
var _2 = "clockIcon--af1xy";
var _3 = "description--D_uKm";
var _4 = "descriptionTooltipWrapper--hYcZm";
var _5 = "folderIcon--h39_K";
var _6 = "footerButtons--rUiKl";
var _7 = "icon--TGA07";
var _8 = "iconContainer--Yei9s";
var _9 = "menuContainer--vfXyu";
var _a = "title--mPY9l";
var _b = "viewSavedButton--T_sGy";
var _c = "viewScheduledButton--bZjup";
export { _1 as "card", _2 as "clockIcon", _3 as "description", _4 as "descriptionTooltipWrapper", _5 as "folderIcon", _6 as "footerButtons", _7 as "icon", _8 as "iconContainer", _9 as "menuContainer", _a as "title", _b as "viewSavedButton", _c as "viewScheduledButton" }
